import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash-es/get';

import { LicenseServiceUrls } from '@portal/portal-core';
import FjAgreementsModal from 'components/agreements-modal';
import { AgreementActions } from 'ducks/agreements-client';
import { AuthClientActions } from 'ducks/auth-client';
import { serverUrl } from '@/Config';

import type { RootState } from 'reducers';
import type { AppDispatch } from 'store';

const EULAModal = (): React.ReactElement => {
  const dispatch = useDispatch<AppDispatch>();
  const agreementId = useSelector((state: RootState) => get(state, 'agreements.agreementId', ''));
  const userId = useSelector((state: RootState) => get(state, 'auth.userId', ''));
  const eulaFileName = useSelector((state: RootState) => get(state, 'agreements.userAgreement', ''));

  const agreeCallback = useCallback(
    () => dispatch(AgreementActions.clientUserAgreementAcceptedSet(userId, agreementId)),
    [dispatch, userId, agreementId],
  );
  const signOutCallback = useCallback(() => dispatch(AuthClientActions.signOut()), [dispatch]);

  const staticEulaPath = `${LicenseServiceUrls.userAgreementsFileUrl(serverUrl)}/${eulaFileName}`;

  return (
    <FjAgreementsModal
      agreementPdfPath={staticEulaPath}
      disagreeCallback={signOutCallback}
      agreeCallback={agreeCallback}
      className=""
    />
  );
};

export default EULAModal;
